import { z } from 'zod';
import { HttpUrl } from './common/url.js';
import { CursorQuery } from './common/pagination.js';
/** Business profile (FR-BIZ-01…11) + reviews (FR-REV-01…05). */
export const CompanyType = z.enum([
    'llc',
    'corporation',
    'nonprofit',
    'partnership',
    'sole_proprietor',
    'pac',
    'party',
    'other',
]);
export const UpsertBusinessInput = z.object({
    legalName: z.string().trim().min(2).max(120),
    tagline: z.string().max(160).optional(),
    logoUrl: HttpUrl.optional(),
    address: z.string().max(200).optional(),
    supportEmail: z.string().email().optional(),
    website: HttpUrl.optional(),
    phone: z.string().max(20).optional(),
    industry: z.string().max(80).optional(),
    companyType: CompanyType,
    specialties: z.array(z.string().max(60)).max(20).default([]),
    establishedYear: z.number().int().min(1800).max(new Date().getFullYear()).optional(),
    about: z.string().max(5_000).optional(),
    templateId: z.string().optional(),
});
export const BusinessView = z.object({
    id: z.string(),
    ownerId: z.string(),
    legalName: z.string(),
    tagline: z.string().optional(),
    logoUrl: z.string().optional(),
    address: z.string().optional(),
    supportEmail: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    industry: z.string().optional(),
    companyType: CompanyType,
    specialties: z.array(z.string()),
    establishedYear: z.number().int().optional(),
    about: z.string().optional(),
    templateId: z.string().nullable(),
    /** ONE source of truth for rating + count (FR-REV-05, closes D-02). */
    averageRating: z.number().min(0).max(5),
    reviewCount: z.number().int().nonnegative(),
    supporterCount: z.number().int().nonnegative(),
    employeeCount: z.number().int().nonnegative(),
    verified: z.boolean(),
    /** viewer-relative */
    mySupport: z.boolean().optional(),
    mutualCount: z.number().int().nonnegative().optional(),
    createdAt: z.coerce.date(),
});
export const EmployeeRow = z.object({
    userId: z.string(),
    displayName: z.string().nullable(),
    jobTitle: z.string().nullable(),
    since: z.coerce.date(),
});
export const CreateReviewInput = z.object({
    rating: z.number().int().min(1).max(5),
    body: z.string().trim().min(1).max(2_000),
});
export const ReviewView = z.object({
    id: z.string(),
    businessId: z.string(),
    authorId: z.string(),
    authorDisplayName: z.string().nullable(),
    rating: z.number().int(),
    body: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const ReviewSummary = z.object({
    averageRating: z.number(),
    reviewCount: z.number().int(),
    distribution: z.record(z.string(), z.number().int()),
});
export const BusinessListQuery = CursorQuery.extend({
    industry: z.string().optional(),
    q: z.string().trim().min(2).max(100).optional(),
});
//# sourceMappingURL=business.js.map